import React from "react";
import "./services.css";

const servicesData = [
  {
    title: "Marketplace & SaaS Platforms",
    items: [
      "Multi-Vendor Marketplaces",
      "Multi-Tenant SaaS & Subscriptions",
      "Admin & Vendor Dashboards",
      "Role-Based Access Control",
      "Payment Gateway Integration",
      "Real-Time Chat & Notifications",
      "Transactional Email Systems",
    ],
  },
  {
    title: "Backend & API Development",
    items: [
      "RESTful API Development",
      "Database Design & Management",
      "Security & Authentication",
      "Third-Party Integrations",
      "Performance Optimization",
      "Cloud Deployment",
      "Version Control & CI/CD",
    ],
  },
  {
    title: "Mobile, MVPs & Customization",
    items: [
      "Android Apps & Play Store Publishing",
      "Progressive Web Apps (PWAs)",
      "MVP Builds for Startups",
      "Rebranding & White-Labeling Existing Platforms",
      "Code Audits & Bug Fixing",
      "Technical SEO for Storefronts",
    ],
  },
];

function Services() {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services_container">
        {servicesData.map((service, index) => (
          <article key={index} className="service">
            <div className="service_head">
              <h3>{service.title}</h3>
            </div>
            <ul className="service_list">
              {service.items.map((item, i) => (
                <li key={i}>
                  <i className="fa-solid fa-check"></i>
                  <p>{item}</p>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Services;